import type { OrderItem } from '../types';

const MAX_IMAGE_FIELD_LEN = 2048;

function slimImageField(value: unknown): string {
  if (typeof value !== 'string' || value.length === 0) return '';
  if (value.startsWith('data:')) return '';
  if (value.length > MAX_IMAGE_FIELD_LEN) return '';
  return value;
}

/**
 * Firestore documents are capped at ~1MB. Order lines extend MenuItem and often carry
 * denormalized catalog fields (notably base64 `data:` image URLs). Strip those before writes.
 */
export function sanitizeOrderItemsForFirestore(items: OrderItem[]): OrderItem[] {
  return items.map((raw) => {
    const item = raw as Record<string, unknown>;
    const slim: Record<string, unknown> = { ...item };

    slim.imageUrl = slimImageField(item.imageUrl);
    const thumb = item.imageUrlThumb;
    slim.imageUrlThumb =
      typeof thumb === 'string' && thumb.length > 0 && !thumb.startsWith('data:') && thumb.length <= MAX_IMAGE_FIELD_LEN
        ? thumb
        : undefined;

    delete slim.description;
    delete slim.meatOptions;
    delete slim.allergens;
    delete slim.allergyWarning;
    delete slim.hasDailyAvailability;
    delete slim.dailyAvailability;
    delete slim.dailyAvailabilityLimit;
    delete slim.lastAvailabilityReset;
    delete slim.isSignatureDish;
    delete slim.isAvailable;

    return slim as OrderItem;
  });
}
